/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';

export const LeftUpArrowIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={className}
      style={style}
      onClick={onClick}
      width="113"
      height="70"
      viewBox="0 0 113 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M64.0935 63.9052C49.4576 63.7577 34.054 62.6249 19.8086 60.4026C16.7288 59.8481 17.8911 57.2291 21.1638 57.6745C33.8696 59.4558 46.7697 60.582 59.8647 60.944C72.9591 61.3061 90.484 61.461 100.704 56.1341C105.911 53.4163 105.732 48.4992 106.127 44.7857C106.719 39.3242 106.541 33.7518 105.977 28.2875C105.606 22.8237 104.658 17.2491 103.517 11.7833C102.947 8.83188 100.071 4.01707 102.581 1.40146C102.774 1.18345 103.352 1.18496 103.544 1.29472C107.968 3.27289 107.761 8.84445 108.524 11.7964C110.047 18.3558 110.801 24.8039 111.361 31.3608C111.918 39.3378 114.775 51.8006 104.166 58.1098C94.9068 63.8764 76.8038 63.9384 64.0935 63.9052Z"
        fill={color}
      />
      <path
        d="M1.83262 62.4385C-0.0896701 61.0854 0.301527 58.7755 2.42243 57.8181C8.97723 55.1394 14.9583 50.9182 21.5131 48.2388C23.4409 47.4735 24.3963 50.3648 22.8531 51.3236C17.838 54.3919 12.8233 57.2675 7.80817 60.3357C9.34681 61.1101 10.8854 61.8844 12.4241 62.6591C14.9251 63.6285 17.4282 63.8277 19.7361 64.9892C21.4674 65.7637 20.691 68.073 19.3414 68.6472C13.9441 70.5586 6.25394 65.5314 1.83262 62.4385Z"
        fill={color}
      />
    </svg>
  );
};
